var router = require('pjax').Router;
var form = require('./form.js');
var index = require('./index.js');

router.get('tier/new', form);
router.get('tier/:any', form);
router.get('tier', index);
